import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, createUrlTreeFromSnapshot, Router } from '@angular/router';

@Component({
    selector: 'header-save-actions',
    templateUrl: './header-save-actions.component.html',
    styleUrls: ['./header-save-actions.component.scss'],
})
export class HeaderSaveActionsComponent {
    @Input() isSaveDisabled = false;
    @Input() isSaveAndProceedDisabled = false;
    @Input() saveAndProceedText: string;
    @Input() saveText: string;
    @Input() nextButtonRouterLink: string;

    @Output() save = new EventEmitter<void>();
    @Output() saveAndProceed = new EventEmitter<void>();
    constructor(private router: Router, private route: ActivatedRoute) {}

    onSave(): void {
        this.save.emit();
    }

    onSaveAndProceed(): void {
        this.saveAndProceed.emit();
        this.navigateTo();
    }

    private navigateTo() {
        const urlTree = createUrlTreeFromSnapshot(this.route.snapshot, [`${this.nextButtonRouterLink}`]);
        this.router.navigateByUrl(urlTree);
    }
}
